import { get } from 'lodash'

import types from './types'

export { default as actions } from './actions'

// Inlined from `getDefaultQuery()` in @scoir/college-search. That package ships
// as a single ~213K pre-bundled module with no `sideEffects: false`, so importing
// this one 2-key default pulled the whole thing into the entry chunk — and this
// reducer is always eager, so every page paid for it. Keep in sync with upstream.
export const INITIAL_STATE = {
  LocationCategory: ['Domestic'],
  Degrees: ['Bachelors'],
}

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.UPDATE_SAVED_PUBLIC_COLLEGE_SEARCH:
      return action.payload
    case types.CLEAR_SAVED_PUBLIC_COLLEGE_SEARCH:
      return INITIAL_STATE
    default:
      return state
  }
}

export default reducer

export const selectSavedPublicCollegeSearch = (store) => {
  return get(store, 'savedPublicCollegeSearch', INITIAL_STATE)
}
